import angular from "angular"
import React from "react"
import Spinner from "@paprika/spinner"
import { react2angular } from "react2angular"
import Button from "@paprika/button"
import "./flexibilityChanger.scss"

function getPitchesString(num) {
  return `unit${num !== 1 ? "s" : ""}`
}

function FlexibilityChanger(props) {
  const renderButtons = () => {
    const oneBehindData = props.flexData.oneBehind
    const oneAheadData = props.flexData.oneAhead
    return (
      <>
        <Button
          kind={Button.types.kind.FLAT}
          size={Button.types.size.SMALL}
          onClick={props.onClickGoPast}
          style={{ marginRight: "10px" }}
          isDisabled={oneBehindData.numOfPitches === 0}
        >
          <div>
            <div>
              <i className="fa fa-arrow-left" /> 1 day{" "}
            </div>
            <div>
              {oneBehindData.numOfPitches} {getPitchesString(oneBehindData.numOfPitches)}
            </div>
          </div>
        </Button>
        <Button
          kind={Button.types.kind.FLAT}
          size={Button.types.size.SMALL}
          onClick={props.onClickGoFuture}
          isDisabled={oneAheadData.numOfPitches === 0}
        >
          <div>
            <div>
              1 day <i className="fa fa-arrow-right" />
            </div>
            <div>
              {oneAheadData.numOfPitches} {getPitchesString(oneAheadData.numOfPitches)}
            </div>
          </div>
        </Button>
      </>
    )
  }

  return (
    <div className="flexibility-changer">
      {props.flexData !== null ? (
        renderButtons()
      ) : (
        <div className="flex-loading-wrapper">
          <span className="flex-loading">Flexible dates</span>{" "}
          <span className="flex-loader-spinner">
            <Spinner size={Spinner.types.size.SMALL} />
          </span>
        </div>
      )}
    </div>
  )
}

export default angular
  .module("directives.flexibilitychanger", [])
  .component("flexibilitychanger", react2angular(FlexibilityChanger, ["flexData", "onClickGoFuture", "onClickGoPast"]))
  .name
